/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingPlansReadApi = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var PricingPlansReadApi = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        PlansService: function () {
            return function (headers) {
                var service = {
                    archivePlan: function (archivePlanRequest) { return httpClient.invoke('POST', '/v1/plans/{id}/archive', archivePlanRequest, headers); },
                    arrangePlans: function (arrangePlansRequest) { return httpClient.invoke('POST', '/v1/plans/arrange', arrangePlansRequest, headers); },
                    countPublicPlans: function (countPublicPlansRequest) {
                        return httpClient.invoke('POST', '/v1/plans/public/count', countPublicPlansRequest, headers);
                    },
                    createPlan: function (createPlanRequest) { return httpClient.invoke('POST', '/v1/plans', createPlanRequest, headers); },
                    getPlan: function (getPlanRequest) { return httpClient.invoke('GET', '/v1/plans/{id}', getPlanRequest, headers); },
                    getPlansStats: function (getPlansStatsRequest) { return httpClient.invoke('GET', '/v1/plans/stats', getPlansStatsRequest, headers); },
                    listPlans: function (listPlansRequest) { return httpClient.invoke('GET', '/v1/plans', listPlansRequest, headers); },
                    listPublicPlans: function (listPublicPlansRequest) {
                        return httpClient.invoke('GET', '/v1/plans/public', listPublicPlansRequest, headers);
                    },
                    makeNoPlanPrimary: function (makeNoPlanPrimaryRequest) {
                        return httpClient.invoke('POST', '/v1/plans/clear-primary', makeNoPlanPrimaryRequest, headers);
                    },
                    makePlanPrimary: function (makePlanPrimaryRequest) {
                        return httpClient.invoke('POST', '/v1/plans/{id}/make-primary', makePlanPrimaryRequest, headers);
                    },
                    queryPublicPlans: function (queryPublicPlansRequest) {
                        return httpClient.invoke('POST', '/v1/plans/public/query', queryPublicPlansRequest, headers);
                    },
                    setPlanVisibility: function (setPlanVisibilityRequest) {
                        return httpClient.invoke('PUT', '/v1/plans/{id}/visibility', setPlanVisibilityRequest, headers);
                    },
                    updatePlan: function (updatePlanRequest) { return httpClient.invoke('PATCH', '/v1/plans/{id}', updatePlanRequest, headers); },
                };
                service.archivePlan.__http_method = 'POST';
                service.archivePlan.__http_url = '/v1/plans/{id}/archive';
                service.arrangePlans.__http_method = 'POST';
                service.arrangePlans.__http_url = '/v1/plans/arrange';
                service.countPublicPlans.__http_method = 'POST';
                service.countPublicPlans.__http_url = '/v1/plans/public/count';
                service.createPlan.__http_method = 'POST';
                service.createPlan.__http_url = '/v1/plans';
                service.getPlan.__http_method = 'GET';
                service.getPlan.__http_url = '/v1/plans/{id}';
                service.getPlansStats.__http_method = 'GET';
                service.getPlansStats.__http_url = '/v1/plans/stats';
                service.listPlans.__http_method = 'GET';
                service.listPlans.__http_url = '/v1/plans';
                service.listPublicPlans.__http_method = 'GET';
                service.listPublicPlans.__http_url = '/v1/plans/public';
                service.makeNoPlanPrimary.__http_method = 'POST';
                service.makeNoPlanPrimary.__http_url = '/v1/plans/clear-primary';
                service.makePlanPrimary.__http_method = 'POST';
                service.makePlanPrimary.__http_url = '/v1/plans/{id}/make-primary';
                service.queryPublicPlans.__http_method = 'POST';
                service.queryPublicPlans.__http_url = '/v1/plans/public/query';
                service.setPlanVisibility.__http_method = 'PUT';
                service.setPlanVisibility.__http_url = '/v1/plans/{id}/visibility';
                service.updatePlan.__http_method = 'PATCH';
                service.updatePlan.__http_url = '/v1/plans/{id}';
                return service;
            };
        },
    };
};
exports.PricingPlansReadApi = PricingPlansReadApi;
exports.PricingPlansReadApi.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map